import React from "react";
import { VZBLTooltip } from "../tooltips/VZBLTooltips";
import { useMemo } from "react";
import { Field } from "src/search/types";

interface MeasureCellProps {
  rawValue: any;
  formattedValue: any;
  colName: string;
  field: Field;
  aggregations: any[];
  formulas?: any[];
  columnInfo: any;
  config: any;
  onClick?: (e: React.MouseEvent) => void;
  depth?: number;
}

export function MeasureCell({
  rawValue,
  formattedValue,
  colName,
  field,
  aggregations,
  formulas = [],
  columnInfo,
  config,
  onClick,
  depth = 0,
}: MeasureCellProps) {
  return (
    <VZBLTooltip
      value={rawValue}
      formattedValue={formattedValue}
      type="measure"
      currentColumn={columnInfo.find((c: any) => c.key == colName)}
      field={field}
      aggregations={aggregations}
      formulas={formulas}
      columnInfo={columnInfo}
      config={config}
    >
      <span
        style={{
          fontWeight: 400,
          fontSize: 12,
          cursor: onClick ? "pointer" : "default",
          display: "flex",
          gap: 6,
          justifyContent: "flex-start",
          paddingLeft: depth * 20,
        }}
        onClick={onClick}
        className="filter-tag-button"
      >
        {formattedValue === null ? (
          <span style={{ fontWeight: 100 }}>-</span>
        ) : (
          formattedValue
        )}
      </span>
    </VZBLTooltip>
  );
}
